module.exports = __webpack_public_path__ + "static/img/4.20882c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/4.png
// module id = iQC6
// module chunks = 0